import { useState } from 'react'
import { Button, Dialog, Portal } from '@chakra-ui/react'
import { toast } from '@/components/ui/toaster/toasterHelpers'
import { deleteOrderAttachment } from '@/api/order-attachments.api'

interface DeleteAttachmentDialogProps {
  isOpen: boolean
  onClose: () => void
  orderId: number
  attachmentId: number | null
  onDeleted: () => void // parent refresh callback
}

export function DeleteAttachmentDialog({
  isOpen,
  onClose,
  orderId,
  attachmentId,
  onDeleted,
}: DeleteAttachmentDialogProps) {
  const [loading, setLoading] = useState(false)

  const handleDelete = async () => {
    if (attachmentId == null) return
    setLoading(true)

    try {
      const updated = await deleteOrderAttachment(orderId, attachmentId)

      toast.success('Anhang gelöscht', 'Der Anhang wurde erfolgreich gelöscht.')

      onClose()
      onDeleted()
    } catch (err) {
      toast.error(
        'Fehler',
        'Der Anhang konnte nicht gelöscht werden. Bitte versuchen Sie es erneut.'
      )
    } finally {
      setLoading(false)
    }
  }

  return (
    <Dialog.Root open={isOpen} onOpenChange={({ open }) => !open && onClose()}>
      <Portal>
        <Dialog.Backdrop />
        <Dialog.Positioner>
          <Dialog.Content>
            <Dialog.Header>
              <Dialog.Title>Anhang löschen</Dialog.Title>
              <Dialog.CloseTrigger />
            </Dialog.Header>

            <Dialog.Body>
              Der Anhang wird unwiderruflich gelöscht. Möchten Sie den Vorgang fortsetzen?
            </Dialog.Body>

            <Dialog.Footer>
              <Button variant="outline" onClick={onClose}>
                Abbrechen
              </Button>
              <Button colorPalette="red" loading={loading} onClick={handleDelete}>
                Anhang löschen
              </Button>
            </Dialog.Footer>
          </Dialog.Content>
        </Dialog.Positioner>
      </Portal>
    </Dialog.Root>
  )
}
